export const staticURL = (url: string) => {
    const baseURL = import.meta.env.VITE_S3_URL + url;
    return baseURL;
}